module.exports = __webpack_public_path__ + "static/img/ac-zz.dae2c2f4.jpg";